import React from "react"
import {Link, useLocation, useNavigate} from "react-router-dom"
import api, {requestFailed} from "../Scripts/api"

function Sidebar() {

    const navigate = useNavigate()
    const account = useLocation().pathname.split('/')[1]
    const location = useLocation().pathname.split('/')[2]

    const logout = () => {
        api.get(`/api/logout`).then((response) => {
            if (response.data.redirect) navigate("/login")
        }).catch(requestFailed)
    }

    return (
        <div id="sidebar">
            <ul id="navlist">
                <li className={location == "profile" ? "navlistitemactive" : "navlistitem"}><Link to={'/' + account + "/profile"}>profile</Link></li>
                <li className={location == "guides" ? "navlistitemactive" : "navlistitem"}><Link to={'/' + account + "/guides"}>guides</Link></li>
                <li className={location == "liked" ? "navlistitemactive" : "navlistitem"}><Link to={'/' + account + "/liked"}>liked</Link></li>
                <li className={location == "settings" ? "navlistitemactive" : "navlistitem"}><Link to={'/' + account + "/settings"}>settings</Link></li>
                <li className="navlistitem" id="logout"><button onClick={logout}>log out</button></li>
            </ul>
        </div>
    )
}

export default Sidebar